import { useMemo } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useBranding } from '../context/BrandingContext';
import { buildUiTokens } from '../theme/brandingTokens';

export function useTokens() {
  const { theme } = useTheme();
  const { branding } = useBranding();

  return useMemo(() => buildUiTokens(branding, theme), [branding, theme]);
}

